"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _color = _interopRequireDefault(require("color"));

function _default(palette) {
  var primary = (0, _color["default"])(palette.elAccent),
      hoverColor;
  hoverColor = primary.rotate(2);
  hoverColor = (0, _color["default"])(hoverColor).saturate(0.3);
  hoverColor = (0, _color["default"])(hoverColor).darken(0.2);
  hoverColor = hoverColor.rgb().string();
  return {
    color: palette.tInactive,
    fontSize: palette.tsNormal,
    lineHeight: 1.5,
    borderColor: palette.elDivider,
    borderStyle: 'solid',
    borderWidth: '1px',
    background: palette.elPrimary,
    padding: "4px ".concat(palette.gutter * 2, "px"),
    borderRadius: '27px',
    boxShadow: 'none',
    hoverColor: palette.tFilled,
    hoverBackground: palette.elPrimary,
    hoverBoxShadow: 'none',
    activeColor: palette.tActive,
    activeBackground: palette.elPrimary,
    activeBoxShadow: 'none',
    labelColor: palette.tLabel,
    labelFontSize: palette.tsXSmall,
    labelLineHeight: palette.tlXSmall,
    maskColor: palette.tInversion,
    maskBackground: palette.elAccent,
    maskBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    maskBorderStyle: 'solid',
    maskBorderColor: 'transparent',
    hoverMaskColor: palette.tInversion,
    hoverMaskBackground: hoverColor,
    hoverMaskBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    hoverMaskBorderStyle: 'solid',
    hoverMaskBorderColor: 'transparent',
    errorLabelColor: palette.tError,
    width: 'auto',
    minWidth: 'auto'
  };
}